import { render, staticRenderFns } from "./ClientNotifications.vue?vue&type=template&id=895c5c50&scoped=true&"
import script from "./ClientNotifications.vue?vue&type=script&lang=js&"
export * from "./ClientNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotifications.vue?vue&type=style&index=0&id=895c5c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c5c50",
  null
  
)

export default component.exports